<div class="search-filter-seperator"></div>
<div class="content">
  <div class="layout-auto-1-auto">
    <div class="grid cols-5">
      <div class="grid-auto-1"
           style="padding-top: 12px; padding-left: 16px">
        <exg-checkbox  [(ngModel)]="valuesClone.inputBlock"
                       [disabled]="correction && correction.rcptCorType && correction.rcptCorType === 99 ? 'true' : 'false'"
                       type="switch" class="span-2"
                       style="width: 24px">
        </exg-checkbox>
        <p class=""
           style="text-align: justify; margin-top: 24px;"
           [ngStyle]="{'color': correction && correction.rcptCorType && correction.rcptCorType === 99 ? 'var(--c-dark-m3)' : ''}">
          {{getRessource('blockEntry')}}
        </p>
      </div>
      <div>
        <exg-input [(ngModel)]="valuesClone.inputSort"
                   [caption]="getRessource('Sort')"
                   type="number">
        </exg-input>
      </div>
      <div class="span-2">
        <exg-input [(ngModel)]="valuesClone.inputTitle"
                   [disabled]="correction && correction.rcptCorType && correction.rcptCorType === 99 ? 'true' : 'false'"
                   [maxlength]="48"
                   [caption]="getRessource('Title')"
                   type="text">
        </exg-input>
      </div>
      <exg-select #VCTyp
                  [(ngModel)]="valuesClone.activeCorrectionMode" (ngModelChange)="resetMenge($event)"
                  [disabled]="correction && correction.rcptCorType && correction.rcptCorType === 99 ? 'true' : 'false'"
                  [list]="correctionMode"
                  [caption]="getRessource('Korrekturart')"
                  listdisplay="enmText" name="Korrekturart"
                  class="">
      </exg-select>
      <div class="span-4"
           *ngIf="valuesClone.inputBlock">
        <button class="md-btn" (click)="addValue()">
          <i class="fa-solid fa-plus-circle"></i>
          {{getRessource('addPosition')}}
        </button>
      </div>
    </div>
    <div class="content">
      <div class="grid-1-auto" *ngFor="let iValue of getValuesClone(); index as i;">
        <div class="grid cols-5">
          <exg-input [(ngModel)]="iValue.inputPosition"
                     [caption]="getRessource('Position')"
                     [disabled]="correction && correction.rcptCorType && correction.rcptCorType === 99 ? 'true' : 'false'"
                     type="text">
          </exg-input>
          <exg-input [(ngModel)]="iValue.inputValueOrig"
                     (ngModelChange)="iValue.inputValueCorr = correction && correction.rcptCorType && correction.rcptCorType === 3 ? 0 : iValue.inputValueOrig"
                     [caption]="getRessource('Rechnungswert')"
                     [class.span-3]="valuesClone.activeCorrectionMode === 1"
                     [class.span-2]="valuesClone.activeCorrectionMode !== 1"
                     [disabled]="correction && correction.rcptCorType && correction.rcptCorType === 99 ? 'true' : 'false'"
                     [step]="0.01" type="number">
          </exg-input>
          <exg-input *ngIf="valuesClone.activeCorrectionMode === 1"
                     [(ngModel)]="iValue.inputMengeOrig"
                     style="margin-right: 4px"
                     (ngModelChange)="iValue.inputMengeCorr = correction && correction.rcptCorType && correction.rcptCorType === 3 ? 0 : iValue.inputMengeOrig"
                     [caption]="getRessource('Rechnungsmenge')"
                     type="number"></exg-input>
          <div *ngIf="valuesClone.activeCorrectionMode === 1"></div>
          <exg-input [(ngModel)]="iValue.inputValueCorr"
                     [caption]="getRessource('Korrekturbetrag')"
                     [class.span-3]="valuesClone.activeCorrectionMode === 1"
                     [class.span-2]="valuesClone.activeCorrectionMode !== 1"
                     [step]="0.01" type="number"
                     [disabled]="correction && correction.rcptCorType && (correction.rcptCorType === 3 || correction.rcptCorType === 1) ? 'true' : 'false'">
          </exg-input>
          <exg-input *ngIf="valuesClone.activeCorrectionMode === 1"
                     [(ngModel)]="iValue.inputMengeCorr"
                     style="margin-right: 4px"
                     [caption]="getRessource('Korrekturmenge')"
                     type="number"
                     [disabled]="correction && correction.rcptCorType && (correction.rcptCorType === 3 || correction.rcptCorType === 1) ? 'true' : 'false'">
          </exg-input>
        </div>
        <div class="typo-center app-space-right_1"
             *ngIf="valuesClone.inputBlock">
          <div class="search-action" (click)="deletePosition(iValue)" >
            <i class="fa-solid fa-trash-alt"></i>
          </div>
        </div>
      </div>
    </div>
    <app-textarea-input #VCCorrectionComment
                        [caption]="enumSvc.getFieldCaption('ReceiptCorrection', 'rcptCorDesc')"
                        [maxCLength]="1048"
                        [value]="valuesClone.inputComment">
    </app-textarea-input>
  </div>
</div>
